"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var bitcoin = _interopRequireWildcard(require("@oipwg/bitcoinjs-lib"));

var _safeBuffer = require("safe-buffer");

var _createHash = _interopRequireDefault(require("create-hash"));

var _bs58check = _interopRequireDefault(require("bs58check"));

var _wif = _interopRequireDefault(require("wif"));

var _varuintBitcoin = _interopRequireDefault(require("varuint-bitcoin"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/** @module util */


function ripemd160(buffer) {
  return (0, _createHash.default)('rmd160').update(buffer).digest();
}

function sha256(buffer) {
  return (0, _createHash.default)('sha256').update(buffer).digest();
}

function hash256(buffer) {
  return sha256(sha256(buffer));
}

function hash160(buffer) {
  return ripemd160(sha256(buffer));
}

function toBase58Check(hash, version) {
  var payload = _safeBuffer.Buffer.allocUnsafe(21);

  payload.writeUInt8(version, 0);
  hash.copy(payload, 1);
  return _bs58check.default.encode(payload);
}
/**
 * @param  {Buffer} key - The buffer for the Private/Public Key to encode
 * @param  {number} version - The specific "version" byte to prepend
 * @return {string} Returns the Base58 encoded Key
 */


function toBase58(key, version) {
  if (!key) {
    return console.log('KEY NULL!!!!');
  }

  return toBase58Check(hash160(key), version);
}
/**
 * Check if a WIF is valid for a specific CoinNetwork
 * @param  {string} key - Base58 WIF Private Key
 * @param  {CoinNetwork} network
 * @return {Boolean}
 */


function isValidWIF(key, network) {
  try {
    var dec = _wif.default.decode(key);

    if (network) {
      return dec.version === network.wif;
    } else {
      return true;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
}
/**
 * Check if a Public Address is valid for a specific CoinNetwork
 * @param  {string} address - Base58 Public Address
 * @param  {CoinNetwork} network
 * @return {Boolean}
 */


function isValidPublicAddress(address, network) {
  try {
    var dec = bitcoin.address.fromBase58Check(address);

    if (network) {
      return dec.version === network.pubKeyHash || dec.version === network.scriptHash;
    } else {
      return true;
    }
  } catch (e) {
    return false;
  }
} // https://github.com/bitcoin/bips/blob/master/bip-0044.mediawiki#account-discovery


function discovery(_x, _x2, _x3, _x4, _x5) {
  return _discovery.apply(this, arguments);
}
/**
 * Check if a given string is in a BIP39 Mnemonic format (is a string, and is at least 2 words long).
 * Please note that this does not validate if the Mnemonic is a valid BIP39 Mnemonic
 * (i.e. defined from Entropy vs a Brain Wallet)
 * @param  {string} mnemonic - BIP39 Mnemonic to check
 * @return {Boolean}
 */


function _discovery() {
  _discovery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(chain, gapLimit, queryPromise, i, coin) {
    var gap, checked, allAddresses, cycle;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            gap = 0;
            checked = 0;
            allAddresses = [];

            cycle = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(myCoin) {
                var batch, queryResultSet, _iterator, _step, adr, used;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        batch = [chain.get()];
                        checked++;

                        while (batch.length < gapLimit) {
                          chain.next();
                          batch.push(chain.get());
                          checked++;
                        }

                        _context.prev = 3;
                        _context.next = 6;
                        return queryPromise(batch, myCoin);

                      case 6:
                        queryResultSet = _context.sent;
                        _context.next = 12;
                        break;

                      case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](3);
                        throw new Error('discovery failed! \n' + _context.t0);

                      case 12:
                        _iterator = _createForOfIteratorHelper(queryResultSet.addresses);

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            adr = _step.value;
                            allAddresses.push(adr);
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                        if (!Array.isArray(queryResultSet.results)) {
                          _context.next = 16;
                          break;
                        }

                        throw new TypeError('Expected query set, not Array');

                      case 16:
                        // iterate batch, guarantees order agnostic of queryPromise result ordering
                        batch.forEach(function (a) {
                          if (queryResultSet.results[toBase58(a.address.publicKey, a.network.pubKeyHash)]) {
                            gap = 0;
                          } else {
                            gap += 1;
                          }
                        });

                        if (!(gap >= gapLimit)) {
                          _context.next = 22;
                          break;
                        }

                        used = checked - gap;
                        return _context.abrupt("return", {
                          used: used,
                          checked: checked,
                          chainIndex: i,
                          addresses: allAddresses
                        });

                      case 22:
                        chain.next();

                      case 23:
                        _context.prev = 23;
                        _context.next = 26;
                        return cycle(myCoin);

                      case 26:
                        return _context.abrupt("return", _context.sent);

                      case 29:
                        _context.prev = 29;
                        _context.t1 = _context["catch"](23);
                        throw new Error(_context.t1);

                      case 32:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[3, 9], [23, 29]]);
              }));

              return function cycle(_x6) {
                return _ref.apply(this, arguments);
              };
            }();

            _context2.prev = 4;
            _context2.next = 7;
            return cycle(coin);

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            throw new Error(_context2.t0);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _discovery.apply(this, arguments);
}

function isMnemonic(mnemonic) {
  if (typeof mnemonic === 'string' && mnemonic.split(' ').length >= 2) {
    return true;
  }

  return false;
}
/**
 * Check if a given string is a BIP39 Entropy string.
 * @param  {string} entropy - The Entropy string to check
 * @return {Boolean}
 */


function isEntropy(entropy) {
  if (typeof entropy === 'string' && entropy.length >= 16 && entropy.length <= 32) {
    return true;
  }

  return false;
}

module.exports = {
  hash160: hash160,
  hash256: hash256,
  toBase58: toBase58,
  isValidPublicAddress: isValidPublicAddress,
  isValidWIF: isValidWIF,
  isMnemonic: isMnemonic,
  isEntropy: isEntropy,
  discovery: discovery,
  varIntBuffer: _varuintBitcoin.default.encode
};